import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withStyles } from '@material-ui/core/styles';

import organizationDuck from '../../redux/modules/organizationDuck';
import railsContextDuck from '../../redux/modules/railsContextDuck';
import Heading from '../../components/Public/LogoAndHeading/Heading';
import Logo from '../../components/Public/LogoAndHeading/Logo';

const mapStateToProps = store => {
  const { $$organizationStore, $$railsContextStore } = store;
  return {
    $$organization: $$organizationStore.get('$$organization'),
    canEditOrganization: organizationDuck.selectors.canEditOrganization(
      $$organizationStore,
      $$railsContextStore
    ),
    isPreviewingWebsite: railsContextDuck.selectors.isPreviewingWebsite(
      $$railsContextStore
    ),
  };
};

const styles = theme => ({
  container: {
    display: 'flex',
    justifyContent: 'flex-start',
    wordBreak: 'break-word',
    marginTop: 16,
    marginBottom: 16,
    [theme.breakpoints.down('md')]: {
      paddingLeft: 8,
      paddingRight: 8,
    },
  },
});

class LogoAndHeadingContainer extends Component {
  constructor(props, context) {
    super(props, context);

    this.organizationActions = bindActionCreators(
      organizationDuck.creators,
      this.props.dispatch
    );
  }

  render() {
    const {
      $$organization,
      canEditOrganization,
      isPreviewingWebsite,
      classes,
    } = this.props;

    const isEditingOrganizaiton = canEditOrganization && !isPreviewingWebsite;

    return (
      <div className={classes.container}>
        <Logo
          organization={$$organization}
          isEditingOrganization={isEditingOrganizaiton}
          onUpdateOrganizationFile={
            this.organizationActions.updateOrganizationFile
          }
        />
        <Heading
          organization={$$organization}
          isEditingOrganization={isEditingOrganizaiton}
          onUpdateOrganization={this.organizationActions.updateOrganization}
        />
      </div>
    );
  }
}

LogoAndHeadingContainer.propTypes = {
  $$organization: PropTypes.object.isRequired,
  canEditOrganization: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
  isPreviewingWebsite: PropTypes.bool.isRequired,

  mobile: PropTypes.bool,
};
LogoAndHeadingContainer.defaultProps = {
  mobile: false,
};

export default withStyles(styles)(
  connect(mapStateToProps)(LogoAndHeadingContainer)
);
